import React, {useState} from 'react';
import {Col, Row, DatePicker, Checkbox} from 'antd';
import localeDatePicker from 'antd/lib/date-picker/locale/ru_RU';
import InputField from '../../../../input-field';
import NumberInputField from '../../../../number-input-field';
import SelectField from '../../../../select-field';
import FieldBlock from '../../../../field-block';
import * as moment from 'moment';
import DividerBlock from "../../../../divider-block";
import i18n from "../../../../../i18n";

export default function CorrespondentBankFields({ stepFields, setFields, getFieldErrors, edit = false }) {
    return (<>
        <DividerBlock label={i18n.t('modals.modalEditLegalEntityNew.divider.correspondentBank')}/>
        <Row gutter={[{ xs: 0, sm: 0, md: 16}, 24]}>
            <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                    name="correspondentBankName"
                    title={i18n.t('modals.modalEditLegalEntityNew.fields.bankName.title')}
                    label={i18n.t('modals.modalEditLegalEntityNew.fields.bankName.title')}
                    required={true}
                    value={stepFields.correspondentBankName}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankName: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                    name="correspondentBankInn"
                    title={i18n.t('modals.modalEditLegalEntityNew.fields.correspondentBankInn.title')}
                    label={i18n.t('modals.modalEditLegalEntityNew.fields.correspondentBankInn.title')}
                    required={true}
                    value={stepFields.correspondentBankInn}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankInn: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                    name="correspondentBankBic"
                    label={i18n.t('modals.modalEditLegalEntityNew.fields.bic.title')}
                    title={i18n.t('modals.modalEditLegalEntityNew.fields.bic.title')}
                    required={true}
                    value={stepFields.correspondentBankBic}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankBic: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                    name="correspondentBankAccount"
                    label={i18n.t('modals.modalEditLegalEntityNew.fields.correspondentBankAccount.title')}
                    title={i18n.t('modals.modalEditLegalEntityNew.fields.correspondentBankAccount.title')}
                    required={true}
                    value={stepFields.correspondentBankAccount}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankAccount: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                    name="correspondentBankCheckingAccount"
                    label={i18n.t('modals.modalEditLegalEntityNew.fields.correspondentBankCheckingAccount.title')}
                    title={i18n.t('modals.modalEditLegalEntityNew.fields.correspondentBankCheckingAccount.title')}
                    required={true}
                    value={stepFields.correspondentBankCheckingAccount}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankCheckingAccount: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
                <InputField
                    name="correspondentBankLegalAddress"
                    label={i18n.t('modals.modalEditLegalEntityNew.fields.correspondentBankLegalAddress.title')}
                    title={i18n.t('modals.modalEditLegalEntityNew.fields.correspondentBankLegalAddress.title')}
                    required={true}
                    value={stepFields.correspondentBankLegalAddress}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankLegalAddress: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
        </Row>
    </>);
}
